export const brandType = ((): string => process.env.REACT_APP_BRAND_TYPE ?? 'vw')();
export const bronsonBrand = ((): string => process.env.REACT_APP_WEBSITE_BRAND ?? 'vw')();
export const localeIdentifier = ((): string => process.env.REACT_APP_LOCALE ?? 'en-GB')();
export const formAutocomplete = ((): string => (process.env.REACT_APP_STAGE === 'prod' ? 'off' : 'on'))();

export const currency = 'EUR';

export const BASE_RESOURCE = 'base';

export const SCP_WIDGET_URL = process.env.REACT_APP_SCP_WIDGET_URL ?? '';
export const SCP_API_KEY = process.env.REACT_APP_SCP_API_KEY ?? '';
export const SCP_WIDGET_BASE_URL = process.env.REACT_APP_SCP_WIDGET_BASE_URL ?? '';
